import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import useDefaultModal from './components/hooks/useDefaultModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import DataTable from './components/DataTable';
import TableContainer from './components/TableContainer';
import ReportMarginModal from './components/modals/ReportMarginModal';

function Margens() {
  const [margins, setMargins] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selecionada, setSelecionada] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const vinculo = JSON.parse(localStorage.getItem('vinculo') || '{}');
  const entidade = vinculo?.entidade || {};
  const entidadeId = entidade.idEntidade || vinculo?.idEntidade;
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (!token) { navigate('/'); return; }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.REPORT_MARGIN}/entidade/${entidadeId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => setMargins(res.data || []))
      .catch(() => setMargins([]))
      .finally(() => setLoading(false));
  }, [atualizar]);

  const normalizeString = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();

  const marginsFiltradas = Array.isArray(margins)
    ? margins.filter(m => normalizeString(m.orientacao || '').includes(normalizeString(filtro)))
    : [];

  const getOrientacaoLabel = o => o === 'R' ? 'Retrato (A4)' : o === 'P' ? 'Paisagem (A4)' : o;

  const cmToPx = v => Math.round((v || 0) * 28.35);

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Margens de Relatório" icon="bi-rulers" />
        <PageContent>
          <div className="d-flex align-items-center mb-2 flex-wrap gap-2" style={{ fontSize: '0.8rem' }}>
            <button className="btn btn-primary btn-sm" onClick={() => { setSelecionada(null); setShowModal(true); }}
              title="Configurar margens">
              <i className="bi bi-pencil-square me-1"></i>Configurar
            </button>
            <span className="text-muted">|</span>
            <div className="d-flex align-items-stretch" style={{ height: '31px' }}>
              <span className="d-flex align-items-center px-2 border border-end-0 rounded-start" style={{ background: '#e9ecef', fontSize: '0.75rem' }}>
                <i className="bi bi-search"></i>
              </span>
              <input type="text" className="form-control form-control-sm border rounded-end" style={{ width: '180px', fontSize: '0.8rem' }}
                placeholder="Buscar..." value={filtro} onChange={e => setFiltro(e.target.value.toUpperCase())} />
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
            <DataTable style={{ fontSize: '0.8rem' }} head={
              <tr>
                <th scope="col" className="px-2">Orientação</th>
                <th scope="col" className="px-2">Topo (cm / px)</th>
                <th scope="col" className="px-2">Base (cm / px)</th>
                <th scope="col" className="px-2">Esquerda (cm / px)</th>
                <th scope="col" className="px-2">Direita (cm / px)</th>
              </tr>}>
              <tbody>
                {!isLoading && marginsFiltradas.map(m => (
                  <tr key={`${m.idEntidade}-${m.orientacao}`}
                    className={selecionada && selecionada.orientacao === m.orientacao ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setSelecionada(selecionada?.orientacao === m.orientacao ? null : m)}>
                    <td className="px-2">
                      <i className={`bi ${m.orientacao === 'R' ? 'bi-phone' : 'bi-tablet-landscape'} me-1`}></i>
                      {getOrientacaoLabel(m.orientacao)}
                    </td>
                    <td className="px-2">{m.marginTop} / {cmToPx(m.marginTop)}</td>
                    <td className="px-2">{m.marginBottom} / {cmToPx(m.marginBottom)}</td>
                    <td className="px-2">{m.marginLeft} / {cmToPx(m.marginLeft)}</td>
                    <td className="px-2">{m.marginRight} / {cmToPx(m.marginRight)}</td>
                  </tr>
                ))}
                {!isLoading && marginsFiltradas.length === 0 && (
                  <tr><td colSpan="5" className="text-center text-muted py-3">Nenhuma margem configurada</td></tr>
                )}
              </tbody>
            </DataTable>
          </TableContainer>

          <DefaultModal {...setDefaultModal} />
        </PageContent>
      </ResponsiveShadow>

      {showModal && (
        <ReportMarginModal show={showModal} idEntidade={entidadeId}
          onClose={() => setShowModal(false)}
          onSuccess={() => setAtualizar(prev => !prev)} />
      )}
    </Layout>
  );
}

export default Margens;
